<div class="shadow nav-header-container myelement1" id="bpgHeader" *ngIf="loginError">
  <div>
    <ul class="nav nav-header ul-styles">
      <li class="nav-item">
        <a class="nav-link img_anchortag">
          <img src="assets/images/image_15.png" alt="" class="logo-img">
        </a>
      </li>
      <li class="nav-item nav-itemList userdetails-margin">
        <a class="nav-link username_anchortag">
          <span id="userName">Hello {{userFirstName}}</span><br>
          <span id="siteLocn">Site location - {{siteName}}</span>
          <!-- <i class="fa fa-user" aria-hidden="true" id="userIcon"></i> -->
        </a>
      </li>
     <li class="nav-item nav-itemList1">
        <a  href = "mailto:is_service_desk@toyota.com" class="a-cursor-color"><i class="fa fa-envelope"></i> Contact Us</a>
      </li>
      <li class="nav-item nav-itemList1">
        <a (click)="logOut()" class="a-cursor"><i class="fa fa-sign-out logout-icon" aria-hidden="true"></i>Logout</a>
      </li>
      <!-- <li class="nav-item nav-itemList">
        <a class="nav-link username_anchortag dropdown-toggle" data-toggle="dropdown">
          <span id="userName">Hello, {{userFirstName}} {{userLastName}}</span>
          <!-- <i class="fa fa-user" aria-hidden="true" id="userIcon"></i> 
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="logOut()">Log Out</a>
          </div>
        </a>
        
      </li> -->
    </ul>
  </div>

  <div>
    <app-navigation-menu></app-navigation-menu>
  </div>
</div>
